import { Flex } from "@chakra-ui/react";
import "bootstrap/dist/css/bootstrap.css";
import { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { baseURL } from "../../../services/api";
import MuralApi from "../../../services/MuralApi";

export interface BannerList {
  ativo: boolean;
  url: string;
}

export default function CarouselComponent() {
  const [images, setimages] = useState(Array<BannerList>);

  async function getImages() {
    try {
      const response = await MuralApi.getImages();
      setimages(response);
      // console.log("response", response);
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    getImages();
  }, []);

  return (
    <Flex w={"60%"} h={"50%"} justifyContent={"center"}>
      <div style={{ display: "block", width: 600,  }}>
        <Carousel fade controls={false} prevIcon={"prevIcon"}>
          {images &&
            images.map((item, index) => {
              const url = item && item.url.split("api")[1];

              return (
                <Carousel.Item key={index} interval={5000}>
                  <img
                    // className="d-block w-100"
                    src={item && `${baseURL}${url}`}
                    alt={`Image ${index}`}
                    style={{
                      // width: "250px",
                      width: "18vw !important",
                      // height: "650px",
                      height: "52vh",
                      overflow: "hidden",
                    }}
                  />
                </Carousel.Item>
              );
            })}
        </Carousel>
      </div>
    </Flex>
  );
}
